module.exports = __webpack_public_path__ + "static/media/year_11.8612692e.jpg";